module.exports = __webpack_public_path__ + "static/media/05.81285423.jpg";